import axios from './axios'

export default {
    signin(username, password, f) {
        axios.post("/auth/signin", {
            username: username,
            password: password
        }).then(function (response) {
            f(response.data)
        })
    },

    signout(f) {
        axios.get("/auth/signout").then(r => f(r.data))
    },

    status(onSuccess, onError) {
        axios.get("/auth/status").then(r => onSuccess(r.data)).catch(error => { if (onError) onError(error) })
    }
}